// extracted by mini-css-extract-plugin
module.exports = {"PrivacyPolicy":"AgreeCheckBox_PrivacyPolicy__1KhqU","ErrorMessage":"AgreeCheckBox_ErrorMessage__Y9avM"};